import { UI } from '../../modules/UI';
import { Common } from '../../modules/Common';
import { App } from '../../modules/App';
import { ValidationRules } from '../../modules/ValidationRules';
import { PageSearch } from '../../modules/PageSearch';
import { Settings } from '../Settings/';
import { appConfig as $config } from '../../app.config';
import { fUploader } from '../../modules/fUploader';

export const CustomerAccount = (function () {
  let $dataGrid;
  let columns = [
    { title: $Lang.user.userName, data: 'userName' },
    { title: $Lang.user.fullName, data: 'fullName' },
    { title: $Lang.user.email, data: 'email' },
    {
      title: $Lang.user.creationDate,
      data: 'createdDate',
      render: (data, type, full) => {
        return data ? `<span class>${moment(data).format($config.appFullDateFormat)}</span>` : ``;
      }
    },
    {
      title: $Lang.user.lastModifiered,
      data: 'lastModifiered',
      render: (data, type, full) => {
        return data ? `<span class>${moment(data).format($config.appFullDateFormat)}</span>` : ``;
      }
    },
    {
      data: null,
      render: (data, type, row) => {
        return `<a href="javascript:" data-id="${row.id}" data-tempid="${row.tempId}" class="link-with-icon js-action-useredit"><i class="fal fa-edit fa-lg ml-1"></i> ${$Lang.btn.edit} </a>`;
      }
    }
  ];

  let mapping = {
    emptylicensor: (data) => {
      return {
        ...data,
        ...{
          allCatalogFilters: data.allCatalogFilters.filter((item) => !!item.title)
        }
      };
    },
    logo: (data) => {
      if (!data?.uri) return null;
      return {
        ...data,
        ...{
          name: data.fileName,
          file: data.uri,
          type: 'image/png',
          size: data.size || ''
        }
      };
    },
    logoOut: (data) => {
      if (!data?.uri) return null;
      return {
        IsAdd: `${data.IsAdd || false}`,
        FileName: data.fileName,
        FileStorageName: data.fileStorageName,
        FileType: `${data.fileType || 0}`,
        Uri: data.uri
      };
    }
  };

  let init = (params = {}, query = '') => {
    UI.block('#page');

    UI.offPageLeaveHandler();
    if (params && params.action) {
      if (params.action == 'edit' && params.id) {
        return editPage(params.id);
      } else if (params.action == 'add') {
        return editPage();
      }
    }

    let requestData = Common.paginationParams('customerAccount', query);
    $.when(App.ajaxData(`/customer/licensor/all`, requestData)).done((res) => {
      let pageData = {
        ...{ licensors: res.values }, // - Page Data
        ...{ pagination: Common.paginationData({ ...requestData, ...res }) }
      };

      let template = require('./tmpl/customerAccount.hbs');
      UI.page(template, pageData).then(pageinit);
    });
  };

  let pageinit = () => {
    PageSearch.init({ selector: '#searchForm' });

    $('#customerAccountAddBtn').on('click', () => {
      $router.push('/customerAccount/add');
    });

    $('#page')
      .off()
      .on('dblclick', '.card-item .detail', (e) => {
        let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
        let id = thisEl.data('itemid');
        $router.push(`/customerAccount/${id}/edit`);
      });

    $('.card-item').css('cursor', 'pointer');
    UI.unblock('#page');
  };

  let editPage = (id = false) => {
    UI.block('#page');

    let queryPath = id ? `/customer/licensor/${id}` : `/customer/licensor/empty`;
    $.when(App.ajaxData(queryPath))
      .done((res) => {
        const accData = mapping.emptylicensor(res.object);
        let template = require('./tmpl/editCustomerAccount.hbs');
        UI.page(template, accData).then(() => editPageInit(accData));
      })
      .always((error) => {
        UI.unblockPage();
      });
  };

  let editPageInit = (data) => {
    UI.unblock('#page');
    let $form = $('#licensorForm');

    new fUploader('input[type="file"]', {
      files: mapping.logo(data.logo),
      fileType: 0,
      limit: 1,
      extensions: ['png', '.jpeg', '.jpg'],
      pageType: 'Logos',
      blockEl: '#licensorForm',
      autostart: true,
      validate: (data) => {
        // Update file data
        App.pageData('logo', data ? data : {});
      },
      complete: (data) => {
        // Update file data
        App.pageData('logo', data[0]);
      }
    });

    $('.form-control-select2', $form).select2();

    dataGridInit(data);

    $('.js-customeraccount-save').on('click', saveAccount);
    $('.js-customeraccount-cancel').on('click', (e) => {
      UI.offPageLeaveHandler();
      $router.push(`/customerAccount`);
    });
  };

  let dataGridInit = (data) => {
    const currentAccount = { id: data.id, accountName: data.name };
    $dataGrid = $('#usersDataTable').DataTable({
      data: data?.users || [],
      cache: false,
      columns: columns,
      drawCallback: function (settings) {
        $('.js-action-useredit')
          .off()
          .on('click', (e) => editUser(e, currentAccount));
        UI.unblock('#page');
      },
      dom: '<"row"<"col-sm-12"t>><"row">'
    });
  };

  let dataGridUpdate = (data) => {
    $dataGrid.clear();
    $dataGrid.rows.add(data);
    $dataGrid.draw();
  };

  let editUser = (e, currentAccount) => {
    let target = $(e.target).hasClass('js-action-useredit') ? $(e.target) : $(e.target).closest('.js-action-useredit');
    let id = target.data('id');
    Settings.editUserDialog(id, updateUsers, currentAccount);
  };

  let updateUsers = (res) => {
    let user = res.createdObject;
    let users = App.pageData('users');

    let exist = false;
    users.forEach(function (el, index) {
      if (user.id === el.id) {
        users[index] = user;
        exist = true;
      }
    });
    if (!exist) {
      users.push(user);
    }

    App.pageData('users', users);
    dataGridUpdate(users);
  };

  let saveAccount = () => {
    let $form = $('#licensorForm');
    $form.validate({ rules: ValidationRules.licensorForm });
    if (!$form.valid()) return false;

    let account = window['DT'];
    let formData = $form.serializeObject();
    let catalogFiltersData = App.pageData('catalogFilters');
    formData = {
      ...account,
      ...formData,
      ...{
        logo: mapping.logoOut(App.pageData('logo')),
        users: App.pageData('users'),
        catalogFilters: Array.isArray(catalogFiltersData) ? catalogFiltersData : []
      }
    };

    UI.block('#licensorForm');
    let url = formData.id ? `/customer/licensor/update` : `/customer/licensor/create/`;
    $.when(App.ajaxData(url, formData, 'POST')) //Getting Brands list
      .done((res) => {
        if (!res.isSuccess) {
          return;
        }

        UI.notify({
          text: $lang.alert.SuccessfullySaved,
          icon: 'fal fa-check-circle',
          type: 'success'
        });

        $router.push(`/customerAccount`);
      })
      .always((error) => {
        UI.unblock('#licensorForm');
      });
    //
  };

  return {
    init,
    saveAccount
  };
})();
